import { render, staticRenderFns } from "./DriveScoreLogo.vue?vue&type=template&id=6170f836&scoped=true"
import script from "./DriveScoreLogo.vue?vue&type=script&lang=js"
export * from "./DriveScoreLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170f836",
  null
  
)

export default component.exports